
import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";
import { socketRequest } from "../../utils/socketRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA, DEV_SET_autoPayAccount } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden, SET_isLoading } from "../../reducers/uiReducer";

import TransactionHistory from "./TransactionHistory";
import AccountSelection from "./AccountSelection";

import moment from 'moment';
import { throttle } from 'lodash';

import MaintenancePay from "./MaintenancePay";
import Checkbox from "../GlobalComponents/Checkbox/Checkbox";

const MaintenancePage: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    const numericTimeInSeconds = moment(hardmoneyData.feeDueDate).unix();
    const formattedDate = moment.unix(numericTimeInSeconds).format("M/D/YYYY");

    const currentTimeMs = moment().valueOf();
    const isOverDue = currentTimeMs >= hardmoneyData.feeDueDate;

    const fetchHouseData = useCallback(
        throttle(async (payAccount: string) => {
          try {
            const res: HardMoneyState = await socketRequest("ChangePayAccount", {
                houseID: hardmoneyData.houseID,
                houseOwner: hardmoneyData.houseOwner,
                payAccount: payAccount,
            }, hardmoneyData);
            
            if (res) {
                if (isEnvBrowser()) {
                    //console.log("SET NEW PAY ACCOUNT", res);
                    dispatch(DEV_SET_autoPayAccount(payAccount));
                } else {
                    dispatch(SET_HOUSEDATA(res));
                };
            } else {
              throw new Error("Invalid pay data received.");
            }
          } catch (err) {
            console.error("Error paydata house data:", err);
          } finally {
            //console.log("set");
          }
        }, 3000),
        [dispatch] 
    );
      

    const setautoPayAccount = (enabled: boolean) => {
        if (enabled) {
            if (playerData.bankAccounts.includes(uiData.selectedAccount)) {
                //console.log("update server with new set account");
                fetchHouseData(uiData.selectedAccount);
            };
        } else {
            if (hardmoneyData.autoPayAccount !== "") {
                fetchHouseData("");
            };
        };
    };
    
    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column",
                textAlign: "left",
               // backgroundColor: "yellow",
                gap: "5vh",
                padding: "3vh 0",
                color: "rgba(255, 255, 255, 0.9)",
            }}
        >
            <div
                style={{
                   // fontWeight: "bold",
                    fontSize: "6vh",
                    //backgroundColor: "orange",
                    fontFamily: 'Oswald',
                    fontWeight: "500",
                }}
            >
                Property Maintenance
            </div>
            
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    //backgroundColor: "gray",
                    boxSizing: "border-box",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        width: "55%",
                        height: "100%",
                        //background: "yellow",
                        boxSizing: "border-box",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        //overflow: "auto",
                        flexDirection: "column",
                        gap: "2vh",
                    }}
                >
                    <div
                        style={{
                            fontSize: "3vh",
                           // fontWeight: "bold",
                           fontFamily: 'Oswald',
                           fontWeight: "500",
                        }}
                    >
                        HISTORY ({hardmoneyData.propertyMaintenance.length} TRANSACTIONS)
                    </div>
                    <TransactionHistory/>
                </div>
                <div
                    style={{
                        width: "37.5%",
                        height: "100%",
                        //background: "orange",
                        boxSizing: "border-box",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        overflow: "hidden",
                        flexDirection: "column",
                        gap: "2vh",
                    }}
                >
                    <div
                        style={{
                            fontSize: "3vh",
                            fontFamily: 'Oswald',
                            fontWeight: "500",
                        }}
                    >
                        OUTGOING FEES
                    </div>
                    
                    <MaintenancePay/>

                    <div
                        style={{
                            fontSize: "3vh",
                            fontFamily: 'Oswald',
                            fontWeight: "500",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "1vh",
                        }}
                    >
                        AUTO PAY
                        <Checkbox
                            checked={hardmoneyData.autoPayAccount !== ""}
                            onChange={setautoPayAccount}
                        />
                    </div>
                    <AccountSelection/>
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;
